module.exports = __webpack_public_path__ + "static/img/news-20210115.8bebc78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news-20210115.png
// module id = ZQUj
// module chunks = 0